import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import Layout from '../../components/Layout';
import PendingActionsTab from './PendingActionsTab';
import BlocklistTab from './BlocklistTab';
import DecisionsHistoryTab from './DecisionsHistoryTab';
import HeldTransactionsTab from './HeldTransactionsTab';
import './styles.css';

const { TabPane } = Tabs;

const FraudCheckManagement = () => {
  const [activeTab, setActiveTab] = useState('pending');

  return (
    <Layout>
      <div className="fraud-container">
        <Card 
          title={<span style={{ fontSize: '18px', fontWeight: 600, color: '#1f1f1f' }}>Fraud Control Management</span>}
          bordered={false}
          style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)' }}
        >
          <Tabs defaultActiveKey="pending" activeKey={activeTab} onChange={setActiveTab} size="large">
            <TabPane tab="Pending Decisions" key="pending">
              {activeTab === 'pending' && <PendingActionsTab />}
            </TabPane>
            <TabPane tab="Counterparty Blocklist" key="blocklist">
              {activeTab === 'blocklist' && <BlocklistTab />}
            </TabPane>
            <TabPane tab="Decisions History" key="history">
              {activeTab === 'history' && <DecisionsHistoryTab />}
            </TabPane>
            <TabPane tab="Held Transactions" key="held">
              {activeTab === 'held' && <HeldTransactionsTab />}
            </TabPane>
          </Tabs>
        </Card>
      </div>
    </Layout>
  );
};

export default FraudCheckManagement;
